//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionDEAd from './dosificacionDEAd'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionDEAd />
            </div>
        );
    }

}
export default Index;